export default function (array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]);
  }
};


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/utils/forEach.js
// module id = null
// module chunks = 